import { IconName } from 'components/Phantom/Icon'

export type TippyPlacement =
	| 'auto'
	| 'auto-start'
	| 'auto-end'
	| 'top'
	| 'top-start'
	| 'top-end'
	| 'bottom'
	| 'bottom-start'
	| 'bottom-end'
	| 'left'
	| 'left-start'
	| 'left-end'
	| 'right'
	| 'right-start'
	| 'right-end'

export enum Theme {
	LIGHT = 'light',
	DARK = 'dark',
}

export interface ImageProps {
	src: string
	alt: string
}

export interface CTAProps {
	text: string
	href: string
}

export interface BenefitProps {
	icon: IconName
	text: string
}

export type FinancingProvider = 'affirm' | 'klarna' | 'none'

export interface Discount {
	type: 'amount' | 'percentage'
	value: number
}
